@if (importValidationResult) {
  <div
    *ngIf="
      !importValidationResult.hints.noGeoData &&
      importValidationResult.hints.featureKeysNotMatch &&
      importValidationResult.hints.missingKeys &&
      importValidationResult.hints.missingKeys.length
    "
    class="mb-3 surface-border border-bottom-1">
    <div class="px-3 pt-1 pb-2" appAlertStyle="warning">
      <h3 class="flex gap-2 align-items-center">
        <i class="fas fa-triangle-exclamation"></i> Hinweis
      </h3>
      <p>Die Importdatei enthält keine Werte für:</p>
      <ul>
        <li *ngFor="let key of importValidationResult.hints.missingKeys">
          <kbd>{{ key }}</kbd>
          {{ importValidationResult.hints.missingFeatures[key]?.name }}
        </li>
      </ul>
    </div>
  </div>
  <div
    *ngIf="importValidationResult.hints.hasEmptyCells"
    class="mb-3 surface-border border-bottom-1">
    <div class="p-3" appAlertStyle="warning">
      <strong>Leere Zellen erkannt:</strong> Diese werden beim Import als
      „k. A.“ (keine Angabe) gespeichert.
    </div>
  </div>
  <div
    *ngIf="importValidationResult.hints.noGeoData"
    class="mb-3 surface-border border-bottom-1">
    <div class="px-3 pt-1 pb-2 m-0" appAlertStyle="info">
      <app-header
        icon="fas fa-circle-info"
        text="Geodaten noch nicht vorhanden"></app-header>
      <p>
        Sie importieren derzeit Daten zu Teilräumen oder Standorten, ohne dass
        Geodaten hinterlegt sind.
      </p>

      <p>
        Die in der Datei enthaltenen Informationen zu
        <b>Name und Schlüssel</b> werden gespeichert und dienen als Grundlage
        für eine spätere Verknüpfung mit Geodaten.
      </p>
      <p>
        Achten Sie beim späteren Import von Geodaten darauf, dass
        <b>Namen und Schlüssel</b> der Teilräume oder Standorte mit diesen
        Angaben übereinstimmen, damit die Zuordnung automatisch erfolgen kann:
      </p>
      <ul class="p-card list-none p-3 flex flex-column gap-2">
        <li
          *ngFor="
            let feature of importValidationResult.hints.featuresToAdd | keyvalue
          ">
          <span class="flex gap-3 align-items-center">
            <code class="kbd">{{ feature.key }}</code>
            {{ feature.value.name }}
          </span>
        </li>
      </ul>
    </div>
  </div>
  <div class="grid">
    <div class="col-6" *ngFor="let severity of validationPreviewSeverities">
      <app-import-preview-box
        [key]="severity"
        [numberOfEntities]="importValidationResult.preview[severity].length"
        (itemsToShow)="setItemsToShow($event)"></app-import-preview-box>
    </div>
  </div>
}
